import React, { useState } from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { fetchGetDeliveryRawStatuses } from './../../../../actions/orders';
import { toast } from 'react-toastify';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

import 'moment/locale/zh-cn';
import 'moment/locale/ru';
moment.locale('zh-cn');
moment.locale('ru');

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;
  font-size: 13px;
  margin-top: 20px;
  .header-title {
    margin-bottom: 15px;
  }
  > div {
    &:last-child {
      padding-bottom: 0;
    }
  }
  .order-history-wrapper {
    display: flex;
    color: #9698a0;
    .order-history-date {
      min-width: 120px;
      width: 120px;
      margin-right: 16px;
      font-size: 12px;
    }
    .order-history-status {
      position: relative;
      font-weight: bold;
      color: #72747b;
      padding-left: 12px;
      border-left: 3px solid #d0d0d0;
      padding-bottom: 30px;
      min-width: 120px;
      margin-right: 18px;
      &:before {
        content: '';
        position: absolute;
        left: -9px;
        top: 0;
        border: 3px solid #d0d0d0;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        background-color: #f2f5f7;
      }
    }
    .order-histoty-text {
      min-width: 250px;
      margin-left: auto;
      margin-right: 25%;
      .order-history-subtype {
        color: #72747b;
      }
    }
    .order-history-description {
      margin-bottom: 10px;
      word-wrap: break-word;
      width: 230px;
    }
    .order-history-icon {
      margin-left: auto;
      font-size: 15px;
      color: #d6d6d6;
    }

    &.full-mode:last-child {
      .order-history-status {
        border-left: none;
        padding-left: 15px;
        &:before {
          left: -6px;
        }
      }
    }
  }
  .more-link-wrapper {
    display: flex;
    justify-content: end;
    border-top: 1px solid #ebebeb;
    margin-top: 5px;
    div {
      margin-top: 5px;
      color: #72747b;
      cursor: pointer;
    }
  }

  .header-title--second {
    margin-top: 25px;
  }

  .handle-raw-statuses {
    cursor: pointer;
  }
`;

const DesktopHistoryBlock = (props) => {
  const { orderHistory, currentOrderId } = props;

  const { t, i18n } = useAutoTranslation();
  const localeCode = i18n.language === 'cn' ? 'zh-cn' : 'ru';

  const [displayFullHistory, setDisplayFullHistory] = useState(false);

  const filteredData = displayFullHistory
    ? orderHistory.slice().reverse()
    : orderHistory.slice().reverse().slice(0, 5);

  return (
    <Wrapper>
      <h4 className="header-title">{t('История заказа')}</h4>
      {filteredData.map((h) => (
        <div
          key={h.id}
          className={`order-history-wrapper ${displayFullHistory ? 'full-mode' : ''}`}
        >
          <div className="order-history-date ">
            {moment(h.eventDate).locale(localeCode).format('DD MMM YYYY HH:mm:ss')}
          </div>
          <div className="order-history-status">{t(h.orderDocStage)}</div>
          <div className="order-histoty-text">
            <div className="order-history-subtype">{h.subType}</div>
            {h.changeSource === `Пользователь` && (
              <div>
                {t('Изменено:')} {h.userLogin}
              </div>
            )}
            {h.description ? (
              <div className="order-history-description">{h.description}</div>
            ) : null}
          </div>
        </div>
      ))}
      {!displayFullHistory ? (
        <div className="more-link-wrapper">
          <div onClick={() => setDisplayFullHistory(true)}>{t('Полная история заказа')}</div>
        </div>
      ) : (
        <div className="more-link-wrapper">
          <div onClick={() => setDisplayFullHistory(false)}>
            {t('Скрыть полную историю заказа')}
          </div>
        </div>
      )}

      <RawDeliveryStatusesBlock currentOrderId={currentOrderId} />
    </Wrapper>
  );
};

export default DesktopHistoryBlock;

const RawDeliveryStatusesBlock = ({ currentOrderId }) => {
  const disptach = useDispatch();

  const [displayRawStatuses, setDisplayRawStatuses] = useState(false);
  const [deliveryRawStatuses, setDeliveryRawStatuses] = useState([]);

  const { t, i18n } = useAutoTranslation();
  const localeCode = i18n.language === 'cn' ? 'zh-cn' : 'ru';

  const handleDisplayRawStatuses = async () => {
    try {
      if (deliveryRawStatuses.length === 0) {
        const res = await disptach(fetchGetDeliveryRawStatuses(currentOrderId));
        setDeliveryRawStatuses(res.statuses);
      }
    } catch (error) {
      toast.error(error.data.errors[0].message || 'Ошибка при загрузке истории доставки');
      setDisplayRawStatuses(false);
      return;
    }

    setDisplayRawStatuses(!displayRawStatuses);
  };

  return (
    <>
      <div className="handle-raw-statuses" onClick={() => handleDisplayRawStatuses()}>
        {!displayRawStatuses
          ? t('Отобразить историю доставки заказа')
          : t('Скрыть историю доставки заказа')}
      </div>
      {displayRawStatuses && deliveryRawStatuses.length > 0 && (
        <h4 className="header-title header-title--second">{t('История доставки заказа')}</h4>
      )}
      {displayRawStatuses &&
        deliveryRawStatuses.length > 0 &&
        deliveryRawStatuses.map((h, idx) => (
          <div key={idx} className={`order-history-wrapper`}>
            <div className="order-history-date ">
              {moment(h.dateTime).locale(localeCode).format('DD MMM YYYY HH:mm:ss')}
            </div>
            <div className="order-history-status">{h.message}</div>
            <div className="order-histoty-text">
              <div className="order-history-subtype">{h.status || ''}</div>
              <div className="order-history-description">{h.city || ''}</div>
            </div>
          </div>
        ))}
    </>
  );
};
